var map = {
	"./en.jpg": "QCv+",
	"./fin.jpg": "Kw4h",
	"./it.jpg": "6eCM",
	"./ru.jpg": "QeGH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vvha";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.jpg$
// module id = vvha
// module chunks = 0